import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { directoryApi, type ApiInfo } from '../client';

const queryKey = ['directory', 'api-info'] as const;

/** Stable query key for cache lookups, invalidations, prefetches, etc. */
useDirectoryApiInfo.queryKey = queryKey;

/**
 * TanStack Query hook over `/directory/api/v1/info/api-info`. Pass through any
 * `useQuery` options you'd like to override (e.g. `enabled`, `staleTime`).
 */
export function useDirectoryApiInfo(
  options?: Omit<UseQueryOptions<ApiInfo, Error>, 'queryKey' | 'queryFn'>,
) {
  return useQuery<ApiInfo, Error>({
    queryKey,
    queryFn: directoryApi.getApiInfo,
    staleTime: 60_000,
    ...options,
  });
}
